import { createFileRoute } from "@tanstack/react-router";
import HowItWorks from "@/pages/HowItWorks";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/how-it-works/")({
  head: () => routeHead("/uk/how-it-works/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <HowItWorks />
  );
}
